import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import { languageHelper } from "../../../../config/helperFunctions";



function PurchaseReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Reference No") || "Reference No",
      accessorKey: "reference_no",
    },
    {
      header: languageHelper("Date") || "Date",
      accessorKey: "date",
    },

    {
      header: languageHelper("Supplier") || "Supplier",
      cell: (row) => row.row.original?.supplier?.name,
    },
    {
      header: languageHelper("Subtotal") || "Subtotal",
      accessorKey: "sub_total",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "vat",
    },
    {
      header: languageHelper("Grand Total") || "Grand Total",
      accessorKey: "grand_total",
    },
    {
      header: languageHelper("Paid") || "Paid",
      accessorKey: "paid",
    },
    {
      header: languageHelper("Due") || "Due",
      accessorKey: "due",
    },
    {
      header: languageHelper("Ingredients") || "Ingredients",
      cell: (row) => {
        // const data = JSON.parse(row.row.original?.ingredients || "[]");
        const data = (
          <span className="text-xs">
            <h2 className="font-bold">
              SN-Ingredient-Qty/Amount-Unit Price-Total
            </h2>
            {JSON.parse(row.row.original?.ingredients || "[]").map(
              (item, idx) => (
                <p index={idx}>{`${idx + 1}-${item.name}-${
                  item.qty
                }-${item.price}-${item.qty * item.price}`}</p>
              )
            )}
          </span>
        );
        return data;
      },
    },
    {
      header: languageHelper("Purchased By") || "Purchased By",
      cell: (row) => row.row.original?.user?.name,
    },
  ];
  const [data, setData] = useState([]);
  // const [users, setUsers] = useState([]);
  const [error, setError] = useState(false);
  // const [selectedUser, setSelectedUser] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };
  // const buttonDataa = [
  //   {
  //     buttonText: "Submit",
  //   },
  // ];

  const footerConfig = {

    "SN": languageHelper("Total") || "Total",
    "Subtotal": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.sub_total) || 0), 0).toFixed(2),
    "Vat": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.vat) || 0), 0).toFixed(2),
    "Grand Total": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.grand_total) || 0), 0).toFixed(2),
    "Paid": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.paid) || 0), 0).toFixed(2),
    "Due": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.due) || 0), 0).toFixed(2),
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/purchase-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          // user_id: selectedUser,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [endDate, selectedOutlet, startDate, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Purchase Report") || "Purchase Report"}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
      />
    </main>
  );
}

export default PurchaseReport;
